{
  "autoZoom": "Auto-Zoom",
  "averageApplicationRateWithVal": "Avg. Application Rate: {{val}}",
  "averagePressureWithVal": "Average Pressure: {{val}}",
  "averageSpeedWithVal": "Average Speed: {{val}}",
  "contrast": "Boost Contrast",
  "durationWithVal": "Duration: {{val}}",
  "linkTo": "Irrigation History",
  "noReelRuns": "No runs were recorded during the selected date range. Adjust the date range or check back later",
  "runsListTitle": "Reel Runs",
  "selectedRunTitleWithRunCount": "Run {{selectedRunIndex}} of {{runCount}}",
  "showBorders": "Show Outlines",
  "startDateWithVal": "Start Date: {{val}}",
  "title": "Irrigation History",
  "totalApplicationWithVal": "Total Application: {{val}} acre-inches.",
  "totalRunsWithItemCount": "Total Runs: {{itemCount}}",
  "useHistoricalNozzle": "Nozzle at run time",
  "flowRateCalculationPrefix": "Calculate flow rate based on:",
  "flowRateCalculationCurrentNozzle": "Currently configured nozzle",
  "flowRateCalculationHistoricalNozzle": "Nozzle as configured at run time",
  "inProgressLabel": "Live",
  "runCountWithVal": "{{val}} runs",
  "headerDateRange": "{{start}} – {{end}}",
  "exportToExcel": "Export to Excel",
  "exportFilename": "irrigation-history",
  "perDayChartTitle": "Application per Day",
  "cumulativeChartTitle": "Cumulative Application",
  "tabRuns": "Runs",
  "tabGraphs": "Graphs",
  "applicationAxisLabel": "Acre-inches",
  "perDayTooltipLabel": "Daily Application",
  "cumulativeTooltipLabel": "Cumulative",
  "noChartData": "No application data in the selected date range",
  "heatmapLegendTitle": "Application Depth",
  "calculationMethod": {
    "flow_rate_override": "Flow rate override",
    "nozzle_diameter_current": "Current nozzle",
    "nozzle_diameter_historical": "Nozzle at run time"
  },
  "applicationType": {
    "water": "Water",
    "manure": "Manure",
    "other": "Other"
  },
  "applicationTypeWithVal": "Applied: {{val}}"
}
